<template>
  <div class="row">
    <el-dialog
      left
      :title="title"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      width="400px"
      @close="handleCancel()"
      style="margin: 0 auto;"
      :visible.sync="isShow"
      class="team-modal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <div>
        <form @submit.prevent="editRole">
          <div class="form-group" v-if="title !='Edit Role'">
            <div class="label">Name</div>
            <input
              type="text"
              class="form-control team-form"
              v-model="value.data.name"
              required
              placeholder="Email"
            />
          </div>
          <div class="form-group">
            <div class="label">Email</div>
            <input
              type="email"
              class="form-control team-form"
              v-model="value.data.email"
              :disabled="title =='Edit Role'"
              required
              placeholder="Email"
            />
          </div>
          <div class="form-group" v-if="title =='Edit Role'">
            <div class="label">Role</div>
            <el-select
              class="todo-dropdown-el-select"
              size="large"
              required
              placeholder="Select Role"
              v-model="value.data.roleId"
            >
              <el-option
                v-for="option in roles"
                class="select-primary"
                :disabled="checkDisabled(option.name)"
                :value="option._id"
                :label="option.name"
                :key="option._id"
              ></el-option>
            </el-select>
          </div>
          <div class="edit-company-action-button-row py-3" style="margin:0px">
            <button
              type="button"
              class="todo-form-cancel-button btn-outline-secondary"
              @click.prevent="handleCancel()"
            >Cancel</button>
            <button
              type="submit"
              class="todo-form-submit-button btn btn-primary"
              style="height: 35px;"
              :disabled="submitted"
            >
              Save
              <b-spinner v-if="submitted" style="float: right;" small label="Loading..."></b-spinner>
            </button>
          </div>
        </form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { Select, Option, Dialog } from "element-ui";
export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Dialog.name]: Dialog,
  },
  computed: {
    ...mapGetters("referrer", ["teamMembers"]),
    checkRole() {
      let index = this.teamMembers.findIndex((item) =>
        item.account && item.account._id
          ? item.account._id == this.$route.params.account_id
          : -1
      );
      if (
        index >= 0 &&
        this.teamMembers[index] &&
        this.teamMembers[index].role &&
        this.teamMembers[index].role.name.length > 0
      )
        return this.teamMembers[index].role.name;
      else return "";
    },
    isShow: {
      get() {
        return this.value.isShow;
      },
      set(value) {
        this.value.isShow = value;
      },
    },
    title: {
      get() {
        return this.value.title ? this.value.title : "";
      },
    },
    roles: {
      get() {
        return this.value.roles ? this.value.roles : [];
      },
    },
  },
  props: {
    value: {
      isShow: Boolean,
      title: String,
      data: Object,
      roles: Array,
    },
  },
  data() {
    return {
      submitted: false,
    };
  },
  methods: {
    checkDisabled(role) {
      let self = this;
      if (self.checkRole && self.checkRole.toLowerCase() == "manager") {
        if (role.toLowerCase() != "manager") return true;
      } else return false;
    },
    editRole() {
      let self = this;
      self.submitted = true;
      let payload = {};
      let url = "";
      if (this.title == "Edit Role") {
        payload = {
          accountWorkspace: this.value.data._id,
          role: this.value.data.roleId,
        };
        url = "referrer/apiEditUser";
      } else {
        payload = {
          _id: this.value.data._id,
          name: this.value.data.name,
          email: this.value.data.email,
        };
        url = "referrer/apiEditReferrer";
      }
      self.$store
        .dispatch(url, payload)
        .then((data) => {
          if (data._id) {
            self.updateStore(this.title, payload);
          }
        })
        .catch((err) => {
          self.$toaster.error("Fail to update referrer details.");
          self.submitted = false;
        });
    },
    updateStore(title, payload) {
      let self = this;
      if (title == "Edit Role") {
        let teamPayload = {
          _id: payload.accountWorkspace,
          roleId: payload.role,
        };
        teamPayload.role = this.value.roles.find(
          (item) => item._id == teamPayload.roleId
        );
        this.$store.commit("referrer/updateTeam", teamPayload);
      } else {
        this.$store.commit("referrer/updateReferrer", payload);
      }
      self.handleCancel();
      self.$toaster.success("Saved successfully.");
    },
    handleCancel() {
      this.submitted = false;
      this.value.isShow = false;
    },
  },
};
</script>
<style>
</style>